var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-create" },
    [
      _c(
        "el-card",
        {
          staticClass: "card",
          style: {
            maxHeight: _vm.screenHeight * 0.8 + "px",
            overflowY: "auto",
          },
        },
        [
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "left-content" },
              [
                _c(
                  "div",
                  { staticClass: "section-header" },
                  [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v("选择酷家乐方案 "),
                      _vm.contractNo
                        ? _c("span", { staticClass: "contract-no" }, [
                            _vm._v("(合同号: " + _vm._s(_vm.contractNo) + ")"),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: {
                          type: "primary",
                          size: "small",
                          plain: "",
                          loading: _vm.refreshLoading,
                        },
                        on: { click: _vm.refreshData },
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh" }),
                        _vm._v("\n            刷新\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.coolHomePlanList.length > 0
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              type: "primary",
                              size: "small",
                              plain: "",
                            },
                            on: { click: _vm.toggleAllExpand },
                          },
                          [
                            _c("i", {
                              class: _vm.isAllExpanded
                                ? "el-icon-arrow-up"
                                : "el-icon-arrow-down",
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.isAllExpanded ? "全部收起" : "全部展开"
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "default", size: "small" },
                        on: { click: _vm.goBack },
                      },
                      [_vm._v("返回")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$parent.checkPer(["admin", "orders:plan"])
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-bottom": "15px" },
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.openCoolHomeDialog },
                      },
                      [_vm._v("关联酷家乐方案")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$parent.checkPer(["admin", "orders:create"])
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-bottom": "15px",
                          "margin-left": "10px",
                        },
                        attrs: {
                          type: "success",
                          size: "small",
                          disabled:
                            _vm.selectedAuditIds.length === 0 ||
                            _vm.hasSelectedChengpinAudit,
                        },
                        on: { click: _vm.handleBatchCreateOrder },
                      },
                      [
                        _vm._v(
                          "批量下单" +
                            _vm._s(
                              _vm.selectedAuditIds.length > 0
                                ? "(" + _vm.selectedAuditIds.length + ")"
                                : ""
                            )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$parent.checkPer(["admin", "orders:tryInstall"])
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-bottom": "15px",
                          "margin-left": "10px",
                        },
                        attrs: {
                          type: "warning",
                          size: "small",
                          disabled: !_vm.canBatchSetTryInstall,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleBatchTryInstall(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "批量试装" +
                            _vm._s(
                              _vm.selectedAuditIds.length > 0
                                ? "(" + _vm.selectedAuditIds.length + ")"
                                : ""
                            )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$parent.checkPer(["admin", "orders:tryInstall"])
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-bottom": "15px",
                          "margin-left": "10px",
                        },
                        attrs: {
                          type: "info",
                          size: "small",
                          disabled: !_vm.canBatchCancelTryInstall,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleBatchTryInstall(false)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "取消试装" +
                            _vm._s(
                              _vm.selectedAuditIds.length > 0
                                ? "(" + _vm.selectedAuditIds.length + ")"
                                : ""
                            )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$parent.checkPer(["admin", "add:chengpin"])
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-bottom": "15px",
                          "margin-left": "10px",
                        },
                        attrs: { type: "warning", size: "small" },
                        on: { click: _vm.openDajiajuOrderDialog },
                      },
                      [_vm._v("大家居订单")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.syncLoading || _vm.orderLoading,
                        expression: "syncLoading || orderLoading",
                      },
                    ],
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      "element-loading-text": "正在处理，请稍候...",
                      "element-loading-spinner": "el-icon-loading",
                      "element-loading-background": "rgba(255, 255, 255, 0.8)",
                    },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticClass: "outer-table",
                        attrs: {
                          data: _vm.coolHomePlanList,
                          "row-key": "rowId",
                          border: "",
                          "expand-row-keys": _vm.expandedRows,
                        },
                        on: { "row-click": _vm.handleRowClick },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "expand" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  props.row.designSchemeAudits &&
                                  props.row.designSchemeAudits.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "expand-content" },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              ref:
                                                "auditTable_" + props.row.rowId,
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                              },
                                              attrs: {
                                                data: props.row
                                                  .designSchemeAudits,
                                                size: "small",
                                                "row-key": "rowId",
                                                border: "",
                                              },
                                              on: {
                                                "row-click":
                                                  _vm.handleAuditRowClick,
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { type: "expand" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          scope.row.boms &&
                                                          scope.row.boms
                                                            .length > 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "boms-expand",
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-table",
                                                                    {
                                                                      attrs: {
                                                                        data: scope
                                                                          .row
                                                                          .boms,
                                                                        size: "mini",
                                                                        border:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "code",
                                                                              label:
                                                                                "编码",
                                                                              "min-width":
                                                                                "150",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "barcode",
                                                                              label:
                                                                                "板件编码",
                                                                              "min-width":
                                                                                "150",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "name",
                                                                              label:
                                                                                "物料名称",
                                                                              "min-width":
                                                                                "150",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "mat",
                                                                              label:
                                                                                "材质",
                                                                              "min-width":
                                                                                "100",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "color",
                                                                              label:
                                                                                "颜色",
                                                                              "min-width":
                                                                                "100",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "length",
                                                                              label:
                                                                                "长度",
                                                                              "min-width":
                                                                                "80",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "width",
                                                                              label:
                                                                                "宽度",
                                                                              "min-width":
                                                                                "80",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "height",
                                                                              label:
                                                                                "厚度",
                                                                              "min-width":
                                                                                "80",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "quantity",
                                                                              label:
                                                                                "数量",
                                                                              "min-width":
                                                                                "80",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "createUserName",
                                                                              label:
                                                                                "创建人",
                                                                              "min-width":
                                                                                "100",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "el-table-column",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              prop: "createTime",
                                                                              label:
                                                                                "创建时间",
                                                                              "min-width":
                                                                                "160",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "boms-expand-empty",
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "center",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "暂无物料清单"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  type: "index",
                                                  label: "序号",
                                                  width: "60",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-table-column",
                                                {
                                                  attrs: {
                                                    label: "操作",
                                                    width: "220",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            scope.row
                                                              .productionStatus ===
                                                              "未提交" ||
                                                            scope.row
                                                              .productionStatus ===
                                                              "回退" ||
                                                            scope.row
                                                              .productionStatus ===
                                                              "退回"
                                                              ? _c(
                                                                  "el-checkbox",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-right":
                                                                          "8px",
                                                                      },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          val
                                                                        ) {
                                                                          return _vm.handleAuditCheckChange(
                                                                            val,
                                                                            scope.row,
                                                                            props.row
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          ._checked,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "_checked",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row._checked",
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            scope.row
                                                              .productionStatus ===
                                                              "未提交" &&
                                                            _vm.$parent.checkPer(
                                                              [
                                                                "admin",
                                                                "orders:create",
                                                              ]
                                                            )
                                                              ? _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      type: "primary",
                                                                      size: "mini",
                                                                      disabled:
                                                                        _vm.isChengpinAudit(
                                                                          scope.row
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCreateOrderFromExpand(
                                                                            scope.row,
                                                                            props.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "下单"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            (scope.row
                                                              .productionStatus ===
                                                              "退回" ||
                                                              scope.row
                                                                .productionStatus ===
                                                                "回退" ||
                                                              scope.row
                                                                .productionStatus ===
                                                                "订单退回") &&
                                                            (scope.row
                                                              .auditStatus ===
                                                              "待审核" ||
                                                              scope.row
                                                                .auditStatus ===
                                                                "审核中" ||
                                                              scope.row
                                                                .auditStatus ===
                                                                "已退回") &&
                                                            _vm.$parent.checkPer(
                                                              [
                                                                "admin",
                                                                "orders:create",
                                                              ]
                                                            )
                                                              ? _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      type: "primary",
                                                                      size: "mini",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleReplenishmentOrder(
                                                                            scope.row,
                                                                            props.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "重新提交"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.$parent.checkPer(
                                                              [
                                                                "admin",
                                                                "sync:productionOrder",
                                                              ]
                                                            )
                                                              ? _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      type: "warning",
                                                                      size: "mini",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleSyncProductionNum(
                                                                            scope.row,
                                                                            props.row
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "更新"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "header" },
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        {
                                                          attrs: {
                                                            indeterminate:
                                                              props.row
                                                                .designSchemeAudits &&
                                                              props.row.designSchemeAudits
                                                                .filter(
                                                                  function (a) {
                                                                    return (
                                                                      a.productionStatus ===
                                                                        "未提交" ||
                                                                      a.productionStatus ===
                                                                        "回退"
                                                                    )
                                                                  }
                                                                )
                                                                .some(function (
                                                                  a
                                                                ) {
                                                                  return a._checked
                                                                }) &&
                                                              !props.row.designSchemeAudits
                                                                .filter(
                                                                  function (a) {
                                                                    return (
                                                                      a.productionStatus ===
                                                                        "未提交" ||
                                                                      a.productionStatus ===
                                                                        "退回"
                                                                    )
                                                                  }
                                                                )
                                                                .every(
                                                                  function (a) {
                                                                    return a._checked
                                                                  }
                                                                ),
                                                            checked:
                                                              props.row
                                                                .designSchemeAudits &&
                                                              props.row.designSchemeAudits.filter(
                                                                function (a) {
                                                                  return (
                                                                    a.productionStatus ===
                                                                      "未提交" ||
                                                                    a.productionStatus ===
                                                                      "回退"
                                                                  )
                                                                }
                                                              ).length > 0 &&
                                                              props.row.designSchemeAudits
                                                                .filter(
                                                                  function (a) {
                                                                    return (
                                                                      a.productionStatus ===
                                                                        "未提交" ||
                                                                      a.productionStatus ===
                                                                        "退回"
                                                                    )
                                                                  }
                                                                )
                                                                .every(
                                                                  function (a) {
                                                                    return a._checked
                                                                  }
                                                                ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              val
                                                            ) {
                                                              return _vm.handleAuditSelectAll(
                                                                val,
                                                                props.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("全选")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "关联特殊申请",
                                                  width: "180",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          scope.row
                                                            .productionStatus ===
                                                            "未提交" ||
                                                          scope.row
                                                            .productionStatus ===
                                                            "回退"
                                                            ? _c(
                                                                "el-select",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%",
                                                                  },
                                                                  attrs: {
                                                                    multiple:
                                                                      "",
                                                                    placeholder:
                                                                      "请选择",
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSpecialApplyChange(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .specialApplication,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope.row,
                                                                          "specialApplication",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.specialApplication",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.specialApplyOptions,
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "el-option",
                                                                      {
                                                                        key: item.id,
                                                                        attrs: {
                                                                          label:
                                                                            item.title,
                                                                          value:
                                                                            item.title,
                                                                        },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .specialApplication
                                                                      ? scope.row.specialApplication.join(
                                                                          ", "
                                                                        )
                                                                      : ""
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "原单号",
                                                  width: "200",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          scope.row
                                                            .productionStatus ===
                                                            "未提交" ||
                                                          scope.row
                                                            .productionStatus ===
                                                            "回退"
                                                            ? _c(
                                                                "el-select",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%",
                                                                  },
                                                                  attrs: {
                                                                    placeholder:
                                                                      "请选择或输入原单号",
                                                                    clearable:
                                                                      "",
                                                                    filterable:
                                                                      "",
                                                                    "allow-create":
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleOriginalOrderChange(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .originalOrder,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope.row,
                                                                          "originalOrder",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.originalOrder",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.originalOrderOptions,
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "el-option",
                                                                      {
                                                                        key: item.productionOrder,
                                                                        attrs: {
                                                                          label:
                                                                            item.productionOrder +
                                                                            " - " +
                                                                            item.auditName,
                                                                          value:
                                                                            item.productionOrder,
                                                                        },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .originalOrder ||
                                                                      "-"
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "auditName",
                                                  label: "审核单名称",
                                                  "min-width": "180",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "auditStatus",
                                                  label: "审核状态",
                                                  "min-width": "100",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "productionOrder",
                                                  label: " 单号",
                                                  "min-width": "180",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "productionStatus",
                                                  label: "销售单状态",
                                                  "min-width": "120",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "createTime",
                                                  label: "创建时间",
                                                  "min-width": "160",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "toolType",
                                                  label: "工具类型",
                                                  "min-width": "150",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "expand-content-empty" },
                                        [_c("span", [_vm._v("暂无提审单信息")])]
                                      ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { type: "index", label: "序号", width: "60" },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { label: "操作", "min-width": "200" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.designSchemeAudits &&
                                    scope.row.designSchemeAudits.some(function (
                                      a
                                    ) {
                                      return (
                                        a.productionStatus === "未提交" ||
                                        a.productionStatus === "回退"
                                      )
                                    })
                                      ? _c("el-checkbox", {
                                          staticStyle: {
                                            "margin-right": "8px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleRowCheckChange(
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row._checked,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "_checked",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row._checked",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "operation-buttons",
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _vm.$parent.checkPer([
                                          "admin",
                                          "orders:plan",
                                        ])
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleDesign(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("设计")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$parent.checkPer([
                                          "admin",
                                          "orders:plan",
                                        ]) && !scope.row.isOrder
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleDeleteScheme(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删除")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$parent.checkPer([
                                          "admin",
                                          "orders:plan",
                                        ]) && !scope.row.isOrder
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "info",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleUnbindScheme(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("取消关联")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$parent.checkPer([
                                          "admin",
                                          "orders:plan",
                                        ])
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "warning",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleSyncData(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("同步数据")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c(
                              "template",
                              { slot: "header" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      indeterminate: _vm.isIndeterminate,
                                      checked: _vm.isAllChecked,
                                    },
                                    on: { change: _vm.handleSelectAll },
                                  },
                                  [_vm._v("全选")]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "designScheme",
                            label: "设计方案号",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "设计方案名称",
                            "min-width": "150",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactPerson",
                            label: "关联人",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "createTime",
                            label: "关联时间",
                            "min-width": "160",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.coolHomeDialogVisible,
            fullscreen: "",
            "append-to-body": "",
            "show-close": false,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.coolHomeDialogVisible = $event
            },
            close: _vm.handleCoolHomeDialogClose,
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "dialog-title" }, [
              _c("span", [_vm._v("酷家乐设计")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cool-home-container" }, [
            _c("iframe", { attrs: { src: _vm.coolHomeFrameUrl } }),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择原单产品",
            visible: _vm.showSelectOrderDialog,
            width: "75%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelectOrderDialog = $event
            },
            open: _vm.handleSelectOrderDialogOpen,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.selectOrderLoading,
                  expression: "selectOrderLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  ref: "orderSelectTable",
                  staticStyle: {
                    width: "100%",
                    "font-size": "14px",
                    cursor: "pointer",
                  },
                  attrs: {
                    data: _vm.originalAuditList,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontWeight: "bold",
                    },
                    border: "",
                    "row-key": "id",
                    "highlight-current-row": "",
                  },
                  on: { "row-click": _vm.handleSelectAuditRow },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionOrder",
                      label: "订单号",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditName",
                      label: "审核单名称",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditStatus",
                      label: "审核状态",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionStatus",
                      label: "销售单状态",
                      "min-width": "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showSelectOrderDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "大家居订单 - 选择成品物料",
            visible: _vm.showDajiajuOrderDialog,
            width: "75%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDajiajuOrderDialog = $event
            },
            open: _vm.loadDajiajuMaterialTable,
            close: _vm.handleDajiajuDialogClose,
          },
        },
        [
          _vm.tempSelectedDajiajuMaterials.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "15px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                        "margin-bottom": "8px",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            color: "#303133",
                          },
                        },
                        [
                          _vm._v(
                            "已选择物料 (" +
                              _vm._s(_vm.tempSelectedDajiajuMaterials.length) +
                              ")"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { color: "#f56c6c" },
                          attrs: { type: "text", size: "mini" },
                          on: { click: _vm.clearDajiajuMaterials },
                        },
                        [_vm._v("清空")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tempSelectedDajiajuMaterials,
                        size: "mini",
                        border: "",
                        "header-cell-style": {
                          backgroundColor: "#f5f7fa",
                          color: "#333",
                          fontWeight: "bold",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "code",
                          label: "编码",
                          "min-width": "140",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "物料名称",
                          "min-width": "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "size",
                          label: "规格",
                          "min-width": "110",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "unitName",
                          label: "单位",
                          "min-width": "60",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "数量", "min-width": "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input-number", {
                                    staticStyle: { width: "90px" },
                                    attrs: {
                                      min: 1,
                                      size: "mini",
                                      "controls-position": "right",
                                    },
                                    model: {
                                      value: scope.row.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "quantity", $$v)
                                      },
                                      expression: "scope.row.quantity",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2709762569
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "70" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#f56c6c" },
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeDajiajuMaterial(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2180765816
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "15px",
                    color: "#909399",
                    "font-size": "13px",
                  },
                },
                [_vm._v("已选择物料：暂无，请从下方列表选择")]
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-form",
                { attrs: { inline: true, size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "编码" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        on: {
                          input: _vm.debouncedDajiajuSearch,
                          clear: _vm.handleDajiajuMaterialSearch,
                        },
                        model: {
                          value: _vm.dajiajuMaterialSearch.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.dajiajuMaterialSearch, "code", $$v)
                          },
                          expression: "dajiajuMaterialSearch.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        on: {
                          input: _vm.debouncedDajiajuSearch,
                          clear: _vm.handleDajiajuMaterialSearch,
                        },
                        model: {
                          value: _vm.dajiajuMaterialSearch.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dajiajuMaterialSearch, "name", $$v)
                          },
                          expression: "dajiajuMaterialSearch.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleDajiajuMaterialSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        { on: { click: _vm.handleDajiajuMaterialSearchReset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dajiajuMaterialLoading,
                  expression: "dajiajuMaterialLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  ref: "dajiajuMaterialTable",
                  staticStyle: { width: "100%", "font-size": "14px" },
                  attrs: {
                    data: _vm.dajiajuMaterialList,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontWeight: "bold",
                    },
                    border: "",
                    "row-key": "id",
                  },
                  on: {
                    "selection-change":
                      _vm.handleDajiajuMaterialSelectionChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "45",
                      "reserve-selection": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "code", label: "编码", "min-width": "150" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "物料名称",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "size", label: "规格", "min-width": "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitName",
                      label: "单位",
                      "min-width": "80",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.dajiajuMaterialPage,
                  "page-size": _vm.dajiajuMaterialPageSize,
                  layout: "total, prev, pager, next",
                  total: _vm.dajiajuMaterialTotal,
                  small: "",
                },
                on: { "current-change": _vm.handleDajiajuMaterialPageChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.dajiajuSubmitting },
                  on: {
                    click: function ($event) {
                      _vm.showDajiajuOrderDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.tempSelectedDajiajuMaterials.length === 0,
                    loading: _vm.dajiajuSubmitting,
                  },
                  on: { click: _vm.confirmDajiajuMaterialSelect },
                },
                [
                  _vm._v(
                    "确定 (已选" +
                      _vm._s(_vm.tempSelectedDajiajuMaterials.length) +
                      ")"
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }